import { createMiddleware } from 'redux-beacon';
import GoogleAnalytics, { trackPageView } from '@redux-beacon/google-analytics'
import debounceEvent from '@redux-beacon/debounce-event';

const getPrefix = (form) => {
    switch(form) {
        case 'InitialApplicationForm':
            return '/IA';
        case 'signupForm':
            return '/SU';
        case 'businessInfoForm':
            return '/MA-BI';
        case 'ownerBasicsForm':
            return '/MA-OW';
        case 'loanAplicationForm':
            return '/MA-LA';
        case 'reviewForm':
            return '/MA-RE';
        default:
            return ''
    }
};

const trackFormEvent = trackPageView((action) => {
    return {
        page: `${getPrefix(action.meta.form)}-${action.meta.field}`
    }
});

// import logger from '@redux-beacon/logger'; // optional
const eventsMap = {
    '@@router/LOCATION_CHANGED': trackPageView((action) => ({
        page: action.payload.pathname,
    })),
    'SIGNUP_SUCCESS': trackPageView(() => ({
        page: '/signup/success'
    })),
    'SAVE_APPLICATION_SUCCESS': trackPageView(() => ({
        page: '/application/success'
    })),
    '@@redux-form/CHANGE': debounceEvent(1000, trackFormEvent)
};

export default createMiddleware(eventsMap, GoogleAnalytics());


// WEBPACK FOOTER //
// ./src/store/analytics.js